export enum UserRoleE {
    INSTALLER = 'installer',
    RESELLER = 'reseller',
    SUPPLIER = 'supplier'
}

export const correctCurrency = '€'
